export default "__VITE_ASSET__CH0SbaD9__"